import { UserRole } from '@modules/core/types';
import { Permissions } from '@modules/permissions/types';

export const WELLSPAN_STAGING = {
  [UserRole.ADMINISTRATOR]: [
    Permissions.COMMUNITY_OUTREACH,
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.GENETIC_COUNSELING,
    Permissions.CAMPAIGN_TRACKING,
    Permissions.CAN_VIEW_PHI,
    /** PAX-1640 Temporary feature to test submit in dev & staging */
    /** This is because Wellspan has a GMI test account and we have a way to create test data */
    Permissions.GENETIC_COUNSELING__CREATE,
  ],
  [UserRole.EXECUTIVE]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
  ],
  [UserRole.MEMBER_LIMITED_PHI]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
  ],
  [UserRole.MEMBER]: [
    Permissions.COMMUNITY_OUTREACH,
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.GENETIC_COUNSELING,
    Permissions.CAMPAIGN_TRACKING,
    Permissions.CAN_VIEW_PHI,
    /** PAX-1640 Temporary feature to test submit in dev & staging */
    /** This is because Wellspan has a GMI test account and we have a way to create test data */
    Permissions.GENETIC_COUNSELING__CREATE,
  ],
};
